jQuery(function () {
    ////////////////////////////////////////////////
    // START - Video block
    if (jQuery('[data-video]').length) {
        // console.log('is a video');
        // Load the IFrame Player API code asynchronously.
        var tag = document.createElement('script');
        tag.src = 'https://www.youtube.com/player_api';
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }
    // END - Video block
    ////////////////////////////////////////////////
});

function onYouTubePlayerAPIReady() {
    // Replace the 'ytplayer' element with an <iframe> and
    // YouTube player after the API code downloads.
    // An array of youtube players
    var players = [];

    jQuery('[data-video]').each(function (index) {
        var videoId = jQuery(this).attr('data-video');
        // console.log({ videoId });
        var elementId = 'ytplayer' + index;
        jQuery(this).attr('id', elementId);
        players[elementId] = new YT.Player(elementId, {
            height: '360',
            width: '640',
            videoId: videoId,

    host: 'https://www.youtube.com',
            playerVars: {
                rel: 0,
                modestbranding: 1,

        'origin': window.location.origin 
            },
            events: {
                onReady: function (event) {
                    var $iframe = jQuery('#' + elementId);
                    $iframe
                        // .attr('loading', 'lazy')
                        .closest('.video-wrap')
                        .removeClass('loading')
                        .addClass('ready');
                    var $playButton = $iframe
                        .closest('.video-wrap')
                        .find('.video-wrap__play');
                    $playButton.removeAttr('disabled');
                    $playButton.on('click', function () {
                        players[elementId].playVideo();
                    });
                },
                onStateChange: function (event) {
                    jQuery('#' + elementId)
                        .closest('.video-wrap')
                        .addClass('interacted');
                }
            }
        });
    });
}
